<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-16">
    <div class="w-full max-w-md rounded-[28px] border border-gray-100 bg-white p-8 shadow-lg">
      <div class="text-center mb-8">
        <p class="text-xs uppercase tracking-[0.4em] text-amber-500 font-semibold">Admin</p>
        <h1 class="mt-2 text-2xl font-bold text-gray-900">Sign in to manage your site</h1>
      </div>

      <div v-if="isDemo" class="mb-6 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-800 leading-relaxed">
        Firebase isn't connected yet, so this is running on a temporary local login.
        Use <span class="font-semibold">{{ demo.email }}</span> / <span class="font-semibold">{{ demo.password }}</span>
        to sign in. Data you add is saved in this browser only until Firebase is configured.
      </div>

      <form @submit.prevent="handleSubmit" class="space-y-4">
        <div>
          <label class="text-xs uppercase tracking-wide text-gray-500">Email</label>
          <input
            v-model="email"
            type="email"
            required
            placeholder="admin@etimad.com"
            class="mt-2 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-amber-500"
          />
        </div>
        <div>
          <label class="text-xs uppercase tracking-wide text-gray-500">Password</label>
          <input
            v-model="password"
            type="password"
            required
            placeholder="••••••••"
            class="mt-2 w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-amber-500"
          />
        </div>

        <p v-if="error" class="text-sm text-red-500">{{ error }}</p>

        <button
          type="submit"
          :disabled="submitting"
          class="w-full rounded-2xl bg-amber-500 py-3 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-amber-600 disabled:opacity-60"
        >
          {{ submitting ? 'Signing in...' : 'Sign In' }}
        </button>
      </form>

      <router-link to="/" class="mt-6 block text-center text-sm text-gray-500 hover:text-amber-600">
        &larr; Back to website
      </router-link>
    </div>
  </div>
</template>

<script>
import { login, isUsingDemoAuth, getDemoCredentials } from '../../services/authStore'

export default {
  name: 'AdminLogin',
  data() {
    return {
      email: '',
      password: '',
      error: '',
      submitting: false,
      isDemo: isUsingDemoAuth(),
      demo: getDemoCredentials()
    }
  },
  methods: {
    async handleSubmit() {
      this.error = ''
      this.submitting = true
      try {
        await login(this.email, this.password)
        const redirect = this.$route.query.redirect || '/admin'
        this.$router.push(redirect)
      } catch (e) {
        this.error = 'Invalid email or password.'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
